<app-header [imgHeader]="img" [titleHeader]="title" [modulo]="'menu'"></app-header>

<div class="row text-center">
  <div class="col-12 mt-5">
    <h2 class="text-grey">¿QUÉ DESEAS REALIZAR?</h2>
  </div>

  <div class="col-10 offset-1">
    <div class="row">
      <div class="col-12">
        <hr>
      </div>

      <div class="col-4" *ngIf="perfilUsuario !== '4' && perfilUsuario !== '11'">
        <a href="#" (click)="menu($event, 'venta-bonos')">
          <div class="box-menu shadow-sm animated bounceInUp faster mt-5">
            <img src="assets/img/compra.png" class="pt-5 pb-3">
            <h5 class="mt-4">COMPRA DE BONO</h5>
          </div>
        </a>
      </div>

      <div class="col-4" *ngIf="gesActivo">
        <a href="#" (click)="menu($event, 'bono-ges')">
          <div class="box-menu shadow-sm animated bounceInUp faster mt-5">
            <img src="assets/img/bonos-ges.png" class="pt-5 pb-3">
            <h5 class="mt-4">COMPRA DE BONO GES</h5>
          </div>
        </a>
      </div>

      <div class="col-4">
        <a href="#" (click)="menu($event, 'pago-bonos')">
          <div class="box-menu shadow-sm animated bounceInUp fast mt-5">
            <img src="assets/img/pago-bonos.png" class="pt-5 pb-3">
            <h5 class="mt-4">BONOS EMITIDOS</h5>
          </div>
        </a>
      </div>

      <div class="col-4">
        <a href="#" (click)="menu($event, 'licencias')">
          <div class="box-menu shadow-sm animated bounceInUp mt-5">
            <img src="assets/img/licencias-medicas.png" class="pt-5 pb-3">
            <h5 class="mt-4">LICENCIAS<br>MÉDICAS</h5>
          </div>
        </a>
      </div>

      <div class="col-4" *ngIf="perfilUsuario !== '4' && perfilUsuario !== '11'">
        <a href="#" (click)="menu($event, 'reembolso')">
          <div class="box-menu shadow-sm animated bounceInUp faster mt-5">
            <img src="assets/img/reembolso.png" class="pt-5 pb-3">
            <h5 class="mt-4">REEMBOLSOS</h5>
          </div>
        </a>
      </div>

      <div class="col-4">
        <a href="#" (click)="menu($event, 'certificados')">
          <div class="box-menu shadow-sm animated bounceInUp fast mt-5">
            <img src="assets/img/certificados.png" class="pt-5 pb-3">
            <h5 class="mt-4">CERTIFICADOS</h5>
          </div>
        </a>
      </div>

      <!-- [ngClass]="{ 'offset-2': gesActivo }" -->
      <div class="col-4" [ngClass]="{ 'offset-2': gesActivo && (perfilUsuario !== '4' && perfilUsuario !== '11') }">
        <a href="#" (click)="menu($event, 'devolucion-exceso')">
          <div class="box-menu shadow-sm animated bounceInUp fast mt-5">
            <img src="assets/img/devolucion.png" class="pt-5 pb-3">
            <h5 class="mt-4">DEVOLUCIÓN DE EXCESOS</h5>
          </div>
        </a>
      </div>

      <div class="col-4" [ngClass]="{ 'offset-4': !gesActivo }">
      <!-- <div class="col-4 offset-4"> -->
        <a href="#" (click)="menu($event, 'pago-cotizaciones')">
          <div class="box-menu shadow-sm animated bounceInUp faster mt-5">
            <img src="assets/img/cotizacion.png" class="pt-5 pb-3">
            <h5 class="mt-4">PAGO DE COTIZACIONES</h5>
          </div>
        </a>
      </div>

      <div class="col-12 mt-5" *ngIf="excedentes > 0">
        <div class="box-excedentes shadow-sm animated bounceInUp fast mt-5">
          <div class="row pt-4">
            <div class="col-1 pt-2 pl-5">
              <img src="assets/img/excedentes.png">
            </div>
            <div class="col-4 pt-3">
              <h4 class="text-grey"> Mis Excedentes:</h4>
            </div>
            <div class="col-7 text-right pr-5">
              <h1 class="text-blue display-4 bold">
                <img src="assets/img/line.png"> {{ excedentes | pesoChileno }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row text-center content-btn w-100">
  <div class="col-12">
    <button class="btn-gral back animated bounceIn slow" (click)="logout()">
      <i class="fas fa-chevron-left mr-4"></i>
      CERRAR SESIÓN
    </button>
  </div>
</div>

<app-footer></app-footer>
